import React, { memo } from "react";

import { Button } from "components/ui/Button";
import { Dialog } from "components/ui/Dialog";

const ConfirmDialogComponent = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  title,
  message,
  confirmLabel = "Confirm",
  confirmVariant = "primary",
  buttonSize = "medium",
  // A confirm dialog should block interaction with what's underneath. When it is
  // opened on top of another Dialog, pass a higher zIndex so its overlay covers
  // that dialog instead of rendering behind it.
  zIndex,
  modal = true,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      title={title}
      width={500}
      zIndex={zIndex}
      modal={modal}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        {/* A div, not a p: callers pass rich messages (lists, callouts) and
            those are not valid inside a paragraph. */}
        <div
          style={{
            fontSize: "16px",
            color: "#26252c",
            fontWeight: 500,
          }}
        >
          {message}
        </div>
        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}
        >
          <Button
            variant="outline"
            size={buttonSize}
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant={confirmVariant}
            size={buttonSize}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? "Processing..." : confirmLabel}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export const ConfirmDialog = memo(ConfirmDialogComponent);
